/*
 * ****************************************************************************
 * Copyright (C) 2018-2018, All rights reserved.
 * Project: chessmate
 * Created On: March 23rd, 2018
 * Last Modified: March 23rd, 2018
 * ****************************************************************************
 */

import * as React from 'react';
import * as Mui from 'mui';
import { RenderPieceFunction } from 'components';
import { ChessRenderInfo, ChessSquare } from 'components/board/chessTypes';
import FenParser from '@chess-fu/fen-parser';

/** PiecesLostProps - Properties */
export interface PiecesLostProps {
  flipBoard: boolean;
  fen: string;
  height: number;
  renderPiece: RenderPieceFunction;
}

/** PiecesLost */
export class PiecesLost extends React.Component<PiecesLostProps> {
  constructor(props: PiecesLostProps, ctx: any) {
    super(props, ctx);
  }

  computeMissing() {
    const finfo = new FenParser(this.props.fen);
    const counts: any = finfo.counts();
    const missing: any = {
      K: 1 - Math.max(counts.K || 0, 0),
      Q: 1 - Math.max(counts.Q || 0, 0),
      B: 2 - Math.max(counts.B || 0, 0),
      N: 2 - Math.max(counts.N || 0, 0),
      R: 2 - Math.max(counts.R || 0, 0),
      P: 8 - Math.max(counts.P || 0, 0),
      k: 1 - Math.max(counts.k || 0, 0),
      q: 1 - Math.max(counts.q || 0, 0),
      b: 2 - Math.max(counts.b || 0, 0),
      n: 2 - Math.max(counts.n || 0, 0),
      r: 2 - Math.max(counts.r || 0, 0),
      p: 8 - Math.max(counts.p || 0, 0),
    };
    for (const key of Object.keys(missing)) {
      const val = missing[key];
      delete missing[key];
      const fq = ((key >= 'a' && key <= 'z') ? 'b' : 'w') + key.toLowerCase();
      missing[fq] = Math.max(0, val);
    }
    return missing;
  }

  renderMissing(missing: { [key: string]: number }, color: string, pieces: string) {
    const height = this.props.height / 2 / pieces.length;
    const size = Math.min(height, 32);
    const renderInfo: ChessRenderInfo = {
      square: { file: '-', rank: 0, color: 'dark', } as any,
      size: { width: size, height: size },
    };

    return pieces.split('')
      .filter(type => missing[`${color}${type}`])
      .map(type => {
        renderInfo.piece = { color, type } as any;
        return (
          <div key={type} style={{ position: 'relative' }}>
            {this.props.renderPiece(renderInfo)}
            <div style={{ position: 'absolute', right: 0, bottom: 0 }}>
              {missing[`${color}${type}`] > 1 ? `${missing[`${color}${type}`]}` : ''}
            </div>
          </div>
        );
      });
  }

  render() {
    const missing = this.computeMissing();
    const order = 'qbnrp';
    const colors = this.props.flipBoard ? 'wb' : 'bw';

    return (
      <div className="row center">
        <div className="flex column top" style={{ height: `${this.props.height}px` }}>
          <div className="fill column" style={{ flexBasis: '50' }}>
            {this.renderMissing(missing, colors[0], order)}
          </div>
          <div className="fill column" style={{ flexBasis: '50' }}>
            {this.renderMissing(missing, colors[1], order)}
          </div>
        </div>
      </div>
    );
  }
}

export default PiecesLost;


// WEBPACK FOOTER //
// ./src/views/playChess/components/piecesLost.tsx